const STORAGE_KEY = 'pricingClipboard_v1';

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

function set(type, payload, meta = {}) {
  const store = readStore();
  store[type] = {
    payload,
    meta: {
      at: Date.now(),
      ...meta, // e.g., { currencyId, sourceLocationId, kind: 'weekday' }
    },
  };
  writeStore(store);
}

function get(type) {
  const store = readStore();
  return store[type]?.payload ?? null;
}

function getMeta(type) {
  const store = readStore();
  return store[type]?.meta ?? null;
}

function has(type) {
  const store = readStore();
  return !!store[type]?.payload;
}

function clear(type) {
  const store = readStore();
  if (type) {
    delete store[type];
  } else {
    // wipe all
    for (const k of Object.keys(store)) delete store[k];
  }
  writeStore(store);
}

export default {
  set,
  get,
  getMeta,
  has,
  clear,
};
